
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.747.01h-5.123L12.5.017a1.052 1.052 0 00.125 2.099h2.72L5.569 11.89l-.085.093a1.052 1.052 0 001.573 1.395l9.777-9.777v2.72l.005.126a1.052 1.052 0 002.099-.125V1.196l.01-.131a1.053 1.053 0 00-1.2-1.054zM2.104.01L1.95.017A2.12 2.12 0 000 2.115v14.728L.006 17a2.12 2.12 0 002.098 1.948h14.729l.155-.005a2.122 2.122 0 001.949-2.099v-6.312l-.006-.125a1.053 1.053 0 00-2.098.125v6.312H2.104V2.115h6.312l.126-.006A1.052 1.052 0 008.416.011z"}})])
          )
        }
      }
    